<template>
  <div>
    <div class="content-box">
      <p class="p1">
        {{ $t("download.title") }}
      </p>
      <div class="c-flex-space-center">
        <div>
          <img class="logo-img" src="@/assets/img/images/logo-black.png" />
          <p class="p2">
            {{ $t("download.title1") }}
          </p>
          <p class="p3">{{ $t("download.title1") }}</p>
          <div class="mt40 c-flex">
            <div>
              <div class="c-flex icon-title">
                <img
                  class="icon-img"
                  src="@/assets/img/images/icon/ios-icon-balck.png"
                />
                <p>
                  {{ $t("download.ios") }}
                </p>
              </div>
              <div class="qr-code-box">
                <!-- <img src="@/assets/img/images/qr-code-black.png" /> -->
				        <qriously :value="$shareUrl + '/#/app'" :size="130" class="qr"/>
              </div>
            </div>
            <div class="ml60">
              <div class="c-flex icon-title">
                <img
                  class="icon-img"
                  src="@/assets/img/images/icon/android-icon-black.png"
                />
                <p>
                  {{ $t("download.android") }}
                </p>
              </div>
              <div class="qr-code-box">
                <!-- <img src="@/assets/img/images/qr-code-black.png" /> -->
				        <qriously :value="'https://rwa.ltd/app/release/rwa-release-1.apk'" :size="130" class="qr"/>
              </div>
            </div>
          </div>
        </div>
        <img class="app-img" src="@/assets/img/images/download-app.png" />
      </div>
    </div>
    <VFooter />
  </div>
</template>

<script>
import VFooter from "@/components/footer/VFooter";
export default {
  name: "download",
  components: {
    VFooter,
  },
  data() {
    return {
	}
  },
  created() {
	  
  },
  mounted() {
  }   
};
</script>

<style lang="less" scoped>
.content-box {
  position: relative;
  padding: 120px 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #f5f6f7;
  background-image: url(~@/assets/img/images/footer-download.png);
  .mt40 {
    margin-top: 40px;
  }
  .ml60 {
    margin-left: 60px;
  }
  .icon-img {
    width: 25px;
    height: 25px;
  }
  .logo-img {
    width: 182px;
    height: 48px;
  }
  .app-img {
    width: 521px;
    height: 576px;
    margin-left: 38px;
  }
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #333333;
    text-align: center;
  }
  .p2 {
    margin-top: 36px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 48px;
    color: #333333;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }
  .icon-title {
    width: 220px;
    height: 48px;
    display: flex;
    gap: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #030303;
    align-items: center;
    justify-content: center;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #000000;
  }
  .qr-code-box {
    padding: 12px;
    width: 160px;
    height: 160px;
    margin: 20px auto;
    background-color: #fff;
    border-radius: 12px 12px 12px 12px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
